// hotel-news.component.ts
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { GlobalService } from "../../services/global.service";

@Component({
  selector: 'app-hotel-news',
  templateUrl: './hotel-news.component.html',
  styleUrls: ['./hotel-news.component.scss']
})
export class HotelNewsComponent {
  @Input() serviceLocationStatus: string;
  @Input() newsLocationStatus: string;
  @Input() serviceResponseArrayModel: any;
  @Output() detailServiceViewEmit = new EventEmitter<string>();
  @Output() editServiceViewEmit = new EventEmitter<string>();

  constructor(public globalService:GlobalService) {
    // Initialize any necessary properties or services here
   
  }
  ngOnInit() {

  }
  // Simplified template for news management
  get isManagePage(): boolean {
    return this.serviceLocationStatus === 'serviceManagePage';
  }

  get homePage():boolean {
    return this.serviceLocationStatus === 'homePage';
  }
   get guestPage():boolean {
    return this.serviceLocationStatus === 'guestPage';
  }
  // Handle edit action
  editNews(id: string) {
    this.editServiceViewEmit.emit(id);
  }

  // Handle view detail action
  viewDetail(id: string) {
    this.detailServiceViewEmit.emit(id);
  }

  getTruncateLimit(): number {
    if (typeof window === 'undefined') {
      return 16;
    }
    return window.innerWidth <= 768 ? 8 : 16;
  }

  truncateText(value: any, limit: number = 16): string {
    const text = (value ?? '').toString().trim();
    if (!text) {
      return '';
    }
    return text.length > limit ? `${text.slice(0, limit)}...` : text;
  }

  isOutsidePublishRange(news: any): boolean {
    const start = this.toUtcDay(news?.VisibilityStartDate);
    const end = this.toUtcDay(news?.VisibilityEndDate);
    if (start === null && end === null) {
      return false;
    }
    const now = new Date();
    const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    return (start !== null && today < start) || (end !== null && today > end);
  }

  private toUtcDay(value: any): number | null {
    if (!value) {
      return null;
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return null;
    }
    return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  }
//   getNewsTitle(news: any): string {
//   // Get the current language from your translation service
//   const currentLang = this.globalService.getLangSaveValue() ||'en';
  
//   // Find the title in the current language, or fall back to the first available
//   const titleObj = news?.NewsName?.find((item: any) => item.Lang === currentLang);
//   return titleObj?.Value || news.NewsName?.[0]?.Value || '';
// }
}